/* ============================================================
   Uplatnica checkout (/pages/clanarina) – sections/uplatnica-checkout.liquid
   Three steps inside [data-uplatnica]: plan pick → form → success.
   POSTs to the Cloudflare worker /order endpoint; the worker owns
   prices, creates Shopify draft orders, emails the QR + PDF. The
   success view renders entirely from the JSON response, so the
   customer gets a payable uplatnica even if email delivery fails.

   THEME-EDITOR-SAFE, same rules as fable.js: per-section state lives on
   the section root, every handler is delegated at document level, and
   boot() re-runs on shopify:section:load. The section loads this file
   itself (defer); a second copy on the same page only re-boots.
   ============================================================ */
(function () {
  'use strict';
  if (window.__uplatnica) { window.__uplatnica.boot(document); return; }

  var doc = document;

  function q(sel, root) { return root.querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function rootOf(el) { return el && el.closest ? el.closest('[data-uplatnica]') : null; }
  function state(root) {
    if (!root.__upl) root.__upl = { plan: null, renderedAt: Date.now() };
    return root.__upl;
  }
  function track(event, params) {
    if (typeof window.gtag === 'function') window.gtag('event', event, params || {});
  }
  function saleOn(root) { return root.getAttribute('data-sale') === '1'; }

  /* Birthday sale display: Liquid renders sale prices while the theme
     switch is on, but rendered pages are CDN-cached and the sale expires
     at birthday_end_date – re-check client-side (same rule as the banner
     and the worker). On expiry, swap back to the regular prices. */
  function saleExpiry(root) {
    if (!saleOn(root)) return;
    var end = root.getAttribute('data-sale-end') || '';
    if (!/^\d{4}-\d{2}-\d{2}$/.test(end)) return;
    if (Date.now() <= new Date(end + 'T23:59:59+02:00').getTime()) return;
    root.setAttribute('data-sale', '0');
    qa('.upl-plan', root).forEach(function (btn) {
      var regular = btn.getAttribute('data-plan-price-regular');
      if (regular) btn.setAttribute('data-plan-price', regular);
    });
  }

  /* Price deadline (theme settings "Cena i rok", body[data-deal-deadline]):
     a page opened after the deadline shows and summarises each plan's
     "Cena posle roka". A page opened before it keeps the old price on
     purpose – the worker honours that for 30 minutes past the deadline
     (it compares the deadline with st.renderedAt), so what someone saw is
     what they pay. Rendered pages are CDN-cached, hence the client check. */
  function dealSwap(root) {
    var iso = doc.body && doc.body.getAttribute('data-deal-deadline');
    var end = iso ? new Date(iso).getTime() : NaN;
    if (isNaN(end) || Date.now() <= end) return;
    qa('[data-plan-price-after]', root).forEach(function (btn) {
      var after = btn.getAttribute('data-plan-price-after');
      if (!after) return;
      btn.setAttribute('data-plan-price-regular', after);
      if (!saleOn(root)) btn.setAttribute('data-plan-price', after);
    });
    qa('[data-upl-price-after]', root).forEach(function (el) {
      el.textContent = el.getAttribute('data-upl-price-after');
    });
  }

  /* Step switch. The fable layout sets html { scroll-behavior: smooth },
     which would animate the jump to the top; the new step should simply
     be there, so smooth scrolling is off for this one call. */
  function showStep(root, name) {
    ['plans', 'checkout', 'success'].forEach(function (k) {
      var el = q('[data-step="' + k + '"]', root);
      if (el) el.hidden = k !== name;
    });
    var html = doc.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    html.style.scrollBehavior = prev;
  }

  function selectPlan(root, btn) {
    var st = state(root);
    /* Black Friday: the sale price while it shows on the card (fable.js
       bfApply, the worker's window), never over the birthday sale. */
    var bf = q('[data-plan-price-bf]', btn);
    st.plan = {
      key: btn.getAttribute('data-plan'),
      label: btn.getAttribute('data-plan-label') || '',
      price: bf && !bf.hidden && !saleOn(root) ? bf.textContent : btn.getAttribute('data-plan-price') || ''
    };
    var labelEl = q('[data-summary-label]', root);
    var priceEl = q('[data-summary-price]', root);
    var noteEl = q('[data-summary-note]', root);
    if (labelEl) labelEl.textContent = st.plan.label;
    if (priceEl) priceEl.textContent = st.plan.price;
    if (noteEl) {
      var isRate = st.plan.key === 'rate3';
      noteEl.hidden = !isRate;
      if (isRate) noteEl.textContent = 'Dobijaš tri uplatnice odjednom – druga rata za 30, treća za 60 dana.';
    }
    showStep(root, 'checkout');
    track('begin_checkout', { plan: st.plan.key, sale: saleOn(root) });
    var first = q('[data-form] input[name="firstName"]', root);
    if (first) first.focus({ preventScroll: true });
  }

  function clearErrors(root) {
    qa('[data-error-for]', root).forEach(function (el) { el.textContent = ''; });
  }
  function showErrors(root, errors) {
    Object.keys(errors || {}).forEach(function (field) {
      var el = q('[data-error-for="' + field + '"]', root);
      if (el) el.textContent = errors[field];
    });
  }
  function setBusy(root, busy) {
    var btn = q('[data-submit]', root);
    var label = q('[data-submit-label]', root);
    if (btn) btn.disabled = busy;
    if (!label) return;
    if (busy) {
      label.__idle = label.textContent;
      label.textContent = 'Kreiramo uplatnicu…';
    } else if (label.__idle) {
      label.textContent = label.__idle;
    }
  }

  function submitOrder(root, form) {
    var st = state(root);
    var workerUrl = (root.getAttribute('data-worker-url') || '').replace(/\/+$/, '');
    var proofEmail = root.getAttribute('data-proof-email') || 'team@tal.as';
    if (!st.plan) { showStep(root, 'plans'); return; }
    if (!workerUrl) {
      showErrors(root, { form: 'Plaćanje trenutno nije dostupno. Piši nam na ' + proofEmail + '.' });
      return;
    }
    clearErrors(root);
    setBusy(root, true);

    var fd = new FormData(form);
    var body = {
      plan: st.plan.key,
      firstName: fd.get('firstName') || '',
      lastName: fd.get('lastName') || '',
      city: fd.get('city') || '',
      phone: fd.get('phone') || '',
      email: fd.get('email') || '',
      newsletter: fd.get('newsletter') === 'on',
      terms: fd.get('terms') === 'on',
      website: fd.get('website') || '',
      t: st.renderedAt
    };

    fetch(workerUrl + '/order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { status: r.status, data: data }; }); })
      .then(function (res) {
        setBusy(root, false);
        if (res.status === 422) { showErrors(root, res.data.errors || {}); return; }
        if (!res.data || res.data.ok !== true || !res.data.payments) {
          showErrors(root, { form: (res.data && res.data.message) || 'Nešto nije u redu. Pokušaj ponovo ili nam piši na ' + proofEmail + '.' });
          return;
        }
        track('uplatnica_order', { plan: st.plan.key, sale: saleOn(root) });
        renderSuccess(root, res.data, body, proofEmail);
        showStep(root, 'success');
      })
      .catch(function () {
        setBusy(root, false);
        showErrors(root, { form: 'Veza nije uspela. Proveri internet pa pokušaj ponovo, ili nam piši na ' + proofEmail + '.' });
      });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function fmtRsd(totalPara) {
    var whole = String(Math.floor(totalPara / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var cents = ('0' + (totalPara % 100)).slice(-2);
    return whole + ',' + cents + ' RSD';
  }

  /* HTML replica of the official NALOG ZA UPLATU form (Cyrillic labels,
     same as the PDF), with the customer filled in as platilac. */
  function nalogHtml(p, body) {
    var u = p.uplatnica;
    var iznos = p.amountLabel.replace(' RSD', '');
    return (
      '<div class="upl-nalog">' +
      '<p class="upl-nalog__title">НАЛОГ ЗА УПЛАТУ</p>' +
      '<div class="upl-nalog__grid">' +
      '<div class="upl-nalog__col">' +
      '<div class="upl-nalog__field"><span>платилац</span><div class="upl-nalog__box">' + esc(body.firstName) + ' ' + esc(body.lastName) + '<br>' + esc(body.city) + '</div></div>' +
      '<div class="upl-nalog__field"><span>сврха уплате</span><div class="upl-nalog__box">' + esc(p.svrha) + '</div></div>' +
      '<div class="upl-nalog__field"><span>прималац</span><div class="upl-nalog__box">' + esc(u.primalac).split(', ').join('<br>') + '</div></div>' +
      '</div>' +
      '<div class="upl-nalog__col">' +
      '<div class="upl-nalog__row">' +
      '<div class="upl-nalog__field upl-nalog__field--s"><span>шифра плаћања</span><div class="upl-nalog__box"><b>' + esc(u.sifra) + '</b></div></div>' +
      '<div class="upl-nalog__field upl-nalog__field--s"><span>валута</span><div class="upl-nalog__box"><b>' + esc(u.valuta) + '</b></div></div>' +
      '<div class="upl-nalog__field upl-nalog__field--grow"><span>износ</span><div class="upl-nalog__box"><b>= ' + esc(iznos) + '</b></div></div>' +
      '</div>' +
      '<div class="upl-nalog__field"><span>рачун примаоца</span><div class="upl-nalog__box"><b>' + esc(u.racun) + '</b></div></div>' +
      '<div class="upl-nalog__field"><span>модел и позив на број (одобрење)</span><div class="upl-nalog__box"><b>' + esc(u.model) + '&nbsp;&nbsp;' + esc(u.pozivNaBroj) + '</b></div></div>' +
      '</div>' +
      '</div>' +
      '<p class="upl-nalog__obrazac">Образац бр. 1</p>' +
      '</div>'
    );
  }

  function renderSuccess(root, data, body, proofEmail) {
    var st = state(root);
    var proof = data.proofEmail || proofEmail;
    var today = new Date();
    var dateStr = ('0' + today.getDate()).slice(-2) + '.' + ('0' + (today.getMonth() + 1)).slice(-2) + '.' + today.getFullYear() + '.';
    var pdfUrl = data.payments[0] && data.payments[0].pdfUrl;
    var totalPara = data.payments.reduce(function (sum, p) {
      return sum + Math.round(parseFloat(p.amount.replace(',', '.')) * 100);
    }, 0);
    var totalLabel = fmtRsd(totalPara);

    var html =
      '<div class="upl-success">' +
      '<div class="upl-success__head upl-card">' +
      '<h2 class="upl__title upl__title--success">Hvala! Tvoja porudžbina je primljena.</h2>' +
      '<dl class="upl-success__meta">' +
      '<div><dt>Broj porudžbine</dt><dd>#' + esc(data.orderNumber) + '</dd></div>' +
      '<div><dt>Datum</dt><dd>' + dateStr + '</dd></div>' +
      '<div><dt>Email</dt><dd>' + esc(body.email) + '</dd></div>' +
      '<div><dt>Ukupno</dt><dd>' + totalLabel + '</dd></div>' +
      '<div><dt>Način plaćanja</dt><dd>Opšta uplatnica</dd></div>' +
      '</dl>' +
      (data.emailSent
        ? '<p class="upl-success__note">Uplatnica sa QR kodom i PDF su poslati na <b>' + esc(body.email) + '</b> (proveri i spam/promotions folder).</p>'
        : '<p class="upl-success__note upl-success__note--warn">Email trenutno nije mogao da se pošalje – sačuvaj podatke sa ove stranice' + (pdfUrl ? ' ili preuzmi PDF ispod' : '') + '.</p>') +
      '</div>';

    data.payments.forEach(function (p) {
      var heading = p.of > 1 ? 'Rata ' + p.rata + '/' + p.of + ' – rok uplate ' + esc(p.dueDate) : 'Tvoja uplatnica – rok uplate ' + esc(p.dueDate);
      html +=
        '<div class="upl-pay upl-card">' +
        '<h3 class="upl-pay__heading">' + heading + '</h3>' +
        '<div class="upl-pay__body upl-pay__body--nalog">' +
        nalogHtml(p, body) +
        '<figure class="upl-pay__qr">' +
        '<img src="data:image/png;base64,' + p.qrPngBase64 + '" width="200" height="200" alt="NBS IPS QR kod za plaćanje">' +
        '<figcaption>NBS IPS QR kod za plaćanje – skeniraj u aplikaciji svoje banke</figcaption>' +
        '</figure>' +
        '</div></div>';
    });

    html +=
      '<div class="upl-success__foot upl-card">' +
      (pdfUrl ? '<a class="upl-btn upl-btn--ghost upl-success__pdf" href="' + esc(pdfUrl) + '" target="_blank" rel="noopener">Preuzmi PDF uplatnicu</a>' : '') +
      '<p><b>Nakon uplate:</b> pošalji potvrdu o uplati (screenshot ili PDF iz aplikacije banke) na ' +
      '<a href="mailto:' + esc(proof) + '">' + esc(proof) + '</a>. ' +
      'Čim evidentiramo uplatu, dobijaš pristup zajednici u roku od 24 h.</p>' +
      '<p class="upl-success__guarantee">7 dana garancije – povraćaj novca bez pitanja.</p>' +
      '</div>' +
      '<div class="upl-success__details upl-card">' +
      '<h3 class="upl-pay__heading">Detalji narudžbine</h3>' +
      '<div class="upl-success__details-body">' +
      '<table class="upl-details__table">' +
      '<tr class="upl-details__cols"><td>Proizvod</td><td>Ukupno</td></tr>' +
      data.payments.map(function (p) {
        var name = esc(st.plan.label) + (p.of > 1 ? ' – rata ' + p.rata + '/' + p.of : '');
        return '<tr><td>' + name + '</td><td><b>' + esc(p.amountLabel) + '</b></td></tr>';
      }).join('') +
      '<tr><td>Ukupno:</td><td><b>' + totalLabel + '</b></td></tr>' +
      '<tr><td>Način plaćanja:</td><td>Opšta uplatnica</td></tr>' +
      '</table>' +
      '<p class="upl-summary__vat">PDV je uključen u cenu.</p>' +
      '</div></div>' +
      '<div class="upl-success__details upl-card">' +
      '<h3 class="upl-pay__heading">Adresa za naplatu</h3>' +
      '<div class="upl-success__details-body">' +
      '<p>' + esc(body.firstName) + ' ' + esc(body.lastName) + '<br>' +
      esc(body.city) + ', Srbija<br>' +
      'Telefon: ' + esc(body.phone) + '<br>' +
      'Email: ' + esc(body.email) + '</p>' +
      '</div></div>' +
      '</div>';

    var success = q('[data-step="success"]', root);
    if (success) success.innerHTML = html;
  }

  /* Per-section init: idempotent, re-run for every section the
     customizer re-renders. */
  function boot(scope) {
    scope = scope || doc;
    var roots = qa('[data-uplatnica]', scope);
    if (scope !== doc && scope.matches && scope.matches('[data-uplatnica]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (root.__upl) return;
      state(root);
      saleExpiry(root);
      dealSwap(root);
      deepLink(root);
    });
  }

  /* Ad deep-links: /pages/clanarina#mesec|#godina|#rate jump straight to
     the form – on load and when the hash changes in place. */
  function deepLink(root) {
    var hash = location.hash.replace(/[^#a-z0-9-]/gi, '');
    if (hash.length < 2) return;
    var target = q('.upl-plan' + hash, root);
    if (target) selectPlan(root, target);
  }

  /* Delegated handlers – bound once, survive any section re-render. */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.upl-plan');
    if (t) {
      var r1 = rootOf(t);
      if (r1) selectPlan(r1, t);
      return;
    }
    t = e.target.closest && e.target.closest('[data-back]');
    if (t) {
      var r2 = rootOf(t);
      if (r2) showStep(r2, 'plans');
    }
  });
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-form]');
    if (!form) return;
    var root = rootOf(form);
    if (!root) return;
    e.preventDefault();
    submitOrder(root, form);
  });
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target || doc); });
  window.addEventListener('hashchange', function () { qa('[data-uplatnica]', doc).forEach(deepLink); });

  window.__uplatnica = { boot: boot };
  boot(doc);
})();
